﻿export const arrayWithoutExistingItem = <T>(array: T[], itemToRemove: T): T[] => ([...array.filter(item => item !== itemToRemove)]);
